import { render, staticRenderFns } from "./comparison-maybearray.vue?vue&type=template&id=1faababe"
import script from "./comparison-maybearray.vue?vue&type=script&lang=js"
export * from "./comparison-maybearray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports